import unionResource from '../resource';

export function getUnions(params) {
  return unionResource.getUnions(params).then(response => response.data);
}

export function getUnion(id) {
  return unionResource.getUnion(id).then(response => response.data);
}

export function createNewUnion(union) {
  return unionResource.createNewUnion(union);
}

export function editUnion(id, union) {
  return unionResource.editUnion(id, union);
}

export function deleteUnion(id) {
  return unionResource.deleteUnion(id);
}

export function getDivisionTypeDescription(value) {
  switch (value) {
  case 'M': return 'Divide pelo número de meses';
  case 'O': return 'Divide pela quantidade de ocorrências';
  default: return null;
  }
}
